import { render, staticRenderFns } from "./AddZoodkomakProduct.vue?vue&type=template&id=162b64e3&"
import script from "./AddZoodkomakProduct.vue?vue&type=script&lang=js&"
export * from "./AddZoodkomakProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports